export default "__VITE_ASSET__0f567c0d__"